import { componentConfig, componentLoader } from "../../lib/component_initializer";
import { Templator } from "./templator";

export const templatorLoader = function (options = {}) {
    componentLoader(componentConfig(Templator, Templator.config.componentTypeKey, Templator.config.baseHtmlClass), options);
};
